// Müşteri sayfaları sekme çubuğu (M16 DR5, mockup 18): Profil · İşletmeler · Performans
// Göstergeleri. Projeler Profil sekmesinde listelenir (RK15: "Projeler (N)" başlığı ve
// "+ Yeni Proje" düğmesi yerinde kalır) — ayrı "Projeler (n)" sekmesi yalnız o bölüme çapaydı,
// Finar rev-A 14 ile kalktı. İşletmeler ayrı sayfa; KPI sekmesi T9 ile gelir
// (`kpiHref` verilmezse render edilmez — izinsiz/henüz yokken DOM'da yoktur).

import { Link } from "react-router-dom";

export type ClientTabKey = "profile" | "entities" | "kpi";

export interface ClientTabsProps {
  clientId: string;
  active: ClientTabKey;
  entityCount?: number | null;
  kpiHref?: string;
}

const tabStyle = (on: boolean): React.CSSProperties => ({
  padding: "10px 14px",
  fontSize: "0.85rem",
  fontWeight: 600,
  color: on ? "var(--color-primary)" : "var(--color-text-2)",
  borderBottom: `2px solid ${on ? "var(--color-primary)" : "transparent"}`,
  marginBottom: -1,
  textDecoration: "none",
});

function count(n: number | null | undefined): string {
  return typeof n === "number" ? ` (${n})` : "";
}

export function ClientTabs(props: ClientTabsProps): JSX.Element {
  const { clientId, active, entityCount, kpiHref } = props;
  return (
    <nav
      aria-label="Müşteri sekmeleri"
      className="flex gap-0.5"
      style={{ borderBottom: "1px solid var(--color-border)", margin: "4px 0 18px" }}
    >
      <Link
        to={`/clients/${clientId}`}
        style={tabStyle(active === "profile")}
        aria-current={active === "profile" ? "page" : undefined}
      >
        Profil
      </Link>
      <Link
        to={`/clients/${clientId}/entities`}
        style={tabStyle(active === "entities")}
        aria-current={active === "entities" ? "page" : undefined}
      >
        İşletmeler{count(entityCount)}
      </Link>
      {kpiHref ? (
        <Link
          to={kpiHref}
          style={tabStyle(active === "kpi")}
          aria-current={active === "kpi" ? "page" : undefined}
        >
          Performans Göstergeleri
        </Link>
      ) : null}
    </nav>
  );
}
